import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import {
  IconDone,
  IconFav,
} from '../../../../core/components/organism/ContentCard/variants';
import { Tag } from '../../../../core/components/atoms/Tag';
import { Colors } from '../../../../core/models/disciplines';
import { IResponseFavorite, useContentFavorite } from '../../hooks/useContentFavorite';

interface IExerciseCard {
  exercise: any;
  discipline: string;
  module: string;
  subject: string;
  subjectSlug: string;
  slug: string;
  done?: boolean;
  favorite: boolean;
  onClose: () => void;
  callback: (data: IResponseFavorite) => void;
}

function summaryExercise(statement: string) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = statement;
  const correctStatement = textarea.value;
  if (correctStatement.length > 100) {
    return correctStatement.substring(0, 100) + '...';
  }
  return correctStatement;
}

function ExerciseCard({
  exercise,
  discipline,
  module,
  subject,
  subjectSlug,
  slug,
  done,
  favorite,
  onClose,
  callback
}: IExerciseCard) {
  const navigate = useNavigate();
  const { mutate, isLoading } = useContentFavorite(true, callback);

  const selected = exercise.slug === slug;
  const selectedBorder = selected
    ? 'border-hairline border-brand-color-primary-pure'
    : null;
  const replacementLink = `/disciplinas/${discipline}/modulo/${module}/assunto/${subjectSlug}/exercicio/${exercise.slug}`;

  const onFavorite = () => {
    mutate({
      category: 'exercise',
      targetId: exercise._id,
      targetType: 'Exercise',
    })
  }

  function getDoneIcon() {
    if (done === undefined) {
      return (
        <Icon
          Icon='check_circle'
          variant='rounded'
          type='material'
          className={IconDone({ type: 'unseen' })}
        />
      );
    }

    return (
      <Icon
        Icon={done ? 'check_circle' : 'cancel'}
        variant='rounded'
        type='material'
        className={IconDone({ type: done ? 'done' : 'incorrect' })}
      />
    );
  }

  return (
    <div
      key={exercise._id}
      className={'flex cursor-pointer rounded-md bg-color-lightest p-4 shadow-level-1 '+selectedBorder}
    >
      <div 
        className='flex flex-1 flex-col gap-sm'
        onClick={() => {
          if (!selected) {
            onClose();
            navigate(replacementLink);
          }
        }}
      >
        <div className='flex flex-row justify-between items-center mb-2'>
          <div className='flex items-center gap-sm'>
            <Icon
              Icon='mode'
              type='material'
              className='text-md text-brand-color-secondary-pure'
            />
            <Typography size='h6' weight='bold' type='titleSection'>
              EXERCÍCIO
            </Typography>
          </div>
          {subject && (
            <Tag
              variant={discipline as Colors}
              className='flex flex-row items-center gap-sm px-2 mr-3'
            >
              <Typography size='small' className='text-[#fff]'>
                {subject}
              </Typography>
            </Tag>
          )}
        </div>
        <Typography size='small'>
          {summaryExercise(exercise.statement)}
        </Typography>
      </div>
      <div className='flex w-fit flex-col items-end justify-between'>
        {getDoneIcon()}
        <Button 
          onlyIcon 
          loading={isLoading} 
          variant='text' 
          size='regular' 
          className='px-0 py-0' 
          onClick={() => onFavorite()}
        >
          <Icon
            Icon='star'
            type='material'
            variant='rounded'
            className={`${IconFav({ type: favorite ? 'favorite' : 'notFavorite' })} filled h-6 w-6 pl-2`}
          />
        </Button>
      </div>
    </div>
  );
}

export default ExerciseCard;
